import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Button, FormControl, InputLabel, Select, MenuItem, Typography, TextField } from "@mui/material";
import LoaderButton from "../../../components/buttons/LoaderButton";
import Container from "../../../components/Grid/Container";
import Row from "../../../components/Grid/Row";
import ColumnInset from "../../../components/Grid/ColumnInset";
import ColumnHeading from "../../../components/Grid/ColumnHeading";
import { editFixedFee, deleteFixedFee } from "../../../redux/slices/tenantManagementSlice";

const EditFixedFee = ({ tenant_uuid, fixed_fee, onBack, heading }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    fixed_name: "",
    fixed_amount: "",
    customer_fixed_fee_verified: false,
    customer_fixed_fee_verified_message: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (fixed_fee) {
      setFormData({
        fixed_name: fixed_fee.fixed_name || "",
        fixed_amount: fixed_fee.fixed_amount || "",
        customer_fixed_fee_verified: fixed_fee.customer_fixed_fee_verified || false,
        customer_fixed_fee_verified_message: fixed_fee.customer_fixed_fee_verified_message || "",
      });
    }
  }, [fixed_fee]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleValidation = () => {
    const newErrors = {};

    if (!formData.fixed_name) {
      newErrors.fixed_name = "Fixed name is required.";
    }

    if (!formData.fixed_amount) {
      newErrors.fixed_amount = "Fixed amount is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!handleValidation()) return;

    try {
      await dispatch(editFixedFee({ tenant_uuid, data: formData })).unwrap();
    } catch (error) {
      console.error("Error updating fixed fee:", error);
    } finally {
      onBack();
    }
  };

  const handleDelete = async () => {
    try {
      await dispatch(deleteFixedFee({ tenant_uuid })).unwrap();
      onBack();
    } catch (error) {
      console.error("Error deleting fixed fee:", error);
    }
  };

  return (
    <Container>
      <Row>
        <ColumnHeading xs={12}>
          <Button onClick={onBack} variant="contained" color="primary" sx={{ marginBottom: 2 }}>
            {heading}
          </Button>
          <Typography variant="h3">Edit Fixed Fee</Typography>
        </ColumnHeading>
      </Row>

      <Row>
        <ColumnInset xs={6}>
          <TextField label="Fixed Name" name="fixed_name" value={formData.fixed_name} onChange={handleChange} error={!!errors.fixed_name} helperText={errors.fixed_name} fullWidth sx={{ marginBottom: 2 }} />

          <TextField label="Fixed Amount" name="fixed_amount" type="number" value={formData.fixed_amount} onChange={handleChange} error={!!errors.fixed_amount} helperText={errors.fixed_amount} fullWidth sx={{ marginBottom: 2 }} />

          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel>Customer Fee Verified</InputLabel>
            <Select name="customer_fixed_fee_verified" value={formData.customer_fixed_fee_verified} onChange={handleChange}>
              <MenuItem value={false}>No</MenuItem>
              <MenuItem value={true}>Yes</MenuItem>
            </Select>
          </FormControl>

          <TextField label="Verification Message" name="customer_fixed_fee_verified_message" value={formData.customer_fixed_fee_verified_message} onChange={handleChange} fullWidth sx={{ marginBottom: 2 }} />

          <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
            <LoaderButton buttonText="Save" onClick={handleSubmit} />
            <LoaderButton buttonText="Delete" onClick={handleDelete} color="error" />
            <LoaderButton buttonText="Cancel" onClick={onBack} />
          </Box>
        </ColumnInset>
      </Row>
    </Container>
  );
};

export default EditFixedFee;
